import Vue from 'vue';
import { SelectionType } from '@/modules/product/model/ProductDto';
export default Vue.extend({
    props: {
        item: Object,
        toast: Boolean,
    },
    data() {
        return {
            SelectionType: SelectionType,
        };
    },
});
